import { render, staticRenderFns } from "./BriqMenuDropdown.vue?vue&type=template&id=3fa291ec&scoped=true&lang=pug&"
import script from "./BriqMenuDropdown.vue?vue&type=script&lang=js&"
export * from "./BriqMenuDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BriqMenuDropdown.vue?vue&type=style&index=0&id=3fa291ec&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa291ec",
  null
  
)

export default component.exports